import httpClient from "../../axios";
import { ENV } from "../../env";

export const API_URL = `https://www.${
  ENV !== "production" ? (ENV === "development" ? "dev" : ENV) + "-" : ""
}manage-mii.uk/api/das/admin/`;



const getGuestsForEvent = async (id) => {
  const response = await httpClient.get(API_URL + `events/${id}/guests`);

  return response.data;
};

const checkIn = async (guestId, eventId) => {
  const response = await httpClient.post(
    `${API_URL}guests/${guestId}/check-in?eventId=${eventId}`,
    {}
  );
  return response.data;
};

const checkOut = async (guestId, eventId) => {
  const response = await httpClient.post(
    `${API_URL}guests/${guestId}/check-out?eventId=${eventId}`,
    {}
  );
  return response.data;
};


const eventManagerService = {
  getGuestsForEvent,
  checkIn,
  checkOut
};

export default eventManagerService;
